"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM5 17H2V3h3v14zm4 0H6V3h3v14zm9 0h-8V3h8v14z"];
//# sourceMappingURL=column-layout.js.map